@if (selectedLogon?.error) {
<pl-error-load-user-info messageType="UNBLOCK_USER"> </pl-error-load-user-info>
} @else {
<seds-modal>
  <div header>Desbloqueio de usuário</div>
  <div content>
    <div class="unblock--container">
      <div class="unblock--container--alert">
        @if (stage === UnblockStageEnum.INITIAL_UNBLOCK || stage ===
        UnblockStageEnum.PASS_UNBLOCK) {
        <ng-container>
          <p class="dialog-content__description">
            O usuário abaixo será DESBLOQUEADO e voltará a ter acesso ao Menu de
            Produtos.
          </p>

          @if (stage === UnblockStageEnum.PASS_UNBLOCK) {
          <p>
            <b>Uma senha temporária será enviada ao e-mail do usuário</b>
          </p>
          }
        </ng-container>
        } @if (stage === UnblockStageEnum.RESET_FLOW_ACTIVE) {
        <ng-container>
          <pl-alert color="success">
            <span header></span>
            <span content>Desbloqueio realizado com sucesso</span>
          </pl-alert>

          <p class="dialog-content__description --bold">
            Deseja redefinir a senha do usuário?
          </p>
        </ng-container>
        } @if (stage === UnblockStageEnum.ERROR) {
        <ng-container>
          <pl-alert color="error" display="column">
            <span header>Não foi possível DESBLOQUEAR o usuário</span>
            <span content
              >Estamos trabalhando para resolver esse problema. Por favor, tente
              novamente mais tarde e, se o erro persistir, entre em contato com
              a nossa equipe de atendimento.</span
            >
          </pl-alert>
        </ng-container>
        } @if (stage === UnblockStageEnum.SUCCESS_EMAIL_SENT) {
        <ng-container>
          <pl-alert color="success" display="column">
            <span header>Desbloqueio realizado com sucesso</span>
            <span content>{{ message }}</span>
          </pl-alert>
        </ng-container>
        } @if (stage === UnblockStageEnum.NEED_EDIT) {
        <ng-container>
          <pl-alert>
            <span content
              >Para desbloquear esse usuário é necessário atualizar seus dados
              cadastrais.</span
            >
          </pl-alert>
        </ng-container>
        }
      </div>

      @if (selectedLogon$ | async; as logon) {
      <section class="unblock--container--user-info dialog-content__box">
        <ul class="dialog-content__box__list">
          <li class="dialog-content__box__list__item">
            Nome:
            <span
              [ngClass]="{
                'dialog-content__box__list__item--bold': logon?.fullname,
                'dialog-content__box__list__item--italic': !logon?.fullname
              }"
              >{{ logon?.fullname || "Não cadastrado" }}</span
            >
          </li>
          @if (logon?.document?.documentCountry === 'BRA' || !logon?.document) {
          <li>
            CPF:
            <span
              [ngClass]="{
                'dialog-content__box__list__item--bold':
                  logon?.document?.documentId,
                'dialog-content__box__list__item--italic':
                  !logon?.document?.documentId
              }"
              >{{
                (logon?.document?.documentId | document : true) ||
                  "Não cadastrado"
              }}</span
            >
          </li>
          } @if (logon?.document?.documentCountry !== 'BRA' && logon?.document)
          {
          <li>
            RNM:
            <span
              [ngClass]="{
                'dialog-content__box__list__item--bold':
                  logon?.document?.documentId,
                'dialog-content__box__list__item--italic':
                  !logon?.document?.documentId
              }"
              >{{ logon?.document?.documentId || "Não cadastrado" }}</span
            >
          </li>
          }
          <li>
            Logon:
            <span
              [ngClass]="{
                'dialog-content__box__list__item--bold': logon?.logon,
                'dialog-content__box__list__item--italic': !logon?.logon
              }"
              >{{ logon?.logon || "Não cadastrado" }}</span
            >
          </li>
          <li>
            E-mail:
            <span
              [ngClass]="{
                'dialog-content__box__list__item--bold': logon?.email,
                'dialog-content__box__list__item--italic': !logon?.email
              }"
              >{{ logon?.email || "Não cadastrado" }}</span
            >
          </li>
          <li>
            Celular: @if (logon?.phone) {
            <span class="dialog-content__box__list__item--bold">{{
              logon?.phone?.areaCode + "" + logon?.phone?.phoneNumber
                | phone : false
            }}</span>
            } @if (!logon?.phone) {
            <span class="dialog-content__box__list__item--italic"
              >Não cadastrado</span
            >
            }
          </li>
        </ul>
      </section>
      }
    </div>
  </div>
  <div class="footer w-100 d-flex justify-content-end" footer>
    @if (stage === UnblockStageEnum.INITIAL_UNBLOCK || stage ===
    UnblockStageEnum.PASS_UNBLOCK) {
    <ng-container>
      <seds-flat-button
        class="btn-cancelar__fade-in"
        data-test="btn-cancelar"
        mat-dialog-close
        title="Cancelar"
        launchLabel="Cancelar"
        launchSection="Clique"
        launchSiteSection="PortalDeLogons"
        plAnalyticsButton
      >
      </seds-flat-button>

      <seds-basic-button
        class="btn-bloquear__fade-in"
        data-test="btn-bloquear"
        [size]="smallButton"
        title="Desbloquear"
        [disabled]="!selectedLogon?.userId || selectedLogon?.error || isLoading"
        (click)="unblockUser()"
        launchLabel="Desbloquear"
        launchSection="Clique"
        launchSiteSection="PortalDeLogons"
        plAnalyticsButton
      >
      </seds-basic-button>
    </ng-container>
    } @if (stage === UnblockStageEnum.RESET_FLOW_ACTIVE) {
    <ng-container>
      <seds-flat-button
        class="btn-manter_senha__fade-in"
        data-test="btn-manter_senha"
        mat-dialog-close
        title="Manter senha"
        launchLabel="Manter senha"
        launchSection="Clique"
        launchSiteSection="PortalDeLogons"
        plAnalyticsButton
      >
      </seds-flat-button>

      <seds-basic-button
        (click)="openResetPassword()"
        mat-dialog-close
        class="btn-redefinir-senha__fade-in"
        data-test="btn-redefinir-senha"
        [size]="smallButton"
        title="Redefinir senha"
        launchLabel="Redefinir senha"
        launchSection="Clique"
        launchSiteSection="PortalDeLogons"
        plAnalyticsButton
      >
      </seds-basic-button>
    </ng-container>
    } @if (stage === UnblockStageEnum.ERROR || stage ===
    UnblockStageEnum.SUCCESS_EMAIL_SENT) {
    <ng-container>
      <seds-basic-button
        mat-dialog-close
        class="btn-concluir__fade-in"
        data-test="btn-concluir"
        [size]="smallButton"
        title="Concluir"
        launchLabel="Concluir"
        launchSection="Clique"
        launchSiteSection="PortalDeLogons"
        plAnalyticsButton
      >
      </seds-basic-button>
    </ng-container>
    } @if (stage === UnblockStageEnum.NEED_EDIT) {
    <ng-container>
      <seds-flat-button
        class="btn-cancelar__fade-in"
        data-test="btn-cancelar"
        mat-dialog-close
        title="Cancelar"
        launchLabel="Cancelar"
        launchSection="Clique"
        launchSiteSection="PortalDeLogons"
        plAnalyticsButton
      >
      </seds-flat-button>

      <seds-basic-button
        class="btn-editar-usuario__fade-in"
        data-test="btn-editar-usuario"
        mat-dialog-close
        [size]="smallButton"
        title="Editar usuário"
        (click)="editUser()"
        launchLabel="Editar Usuário"
        launchSection="Clique"
        launchSiteSection="PortalDeLogons"
        plAnalyticsButton
      >
      </seds-basic-button>
    </ng-container>
    }
  </div>
</seds-modal>
}
